import { easeSnappy, durMedium } from './easings.js';
import { prefersReducedMotion } from './prefersReducedMotion.js';

/** x + opacity entrance from the left. */
export default () => ({
  init() {
    if (prefersReducedMotion()) return;
    window.gsap.from(this.$el, {
      x: -40,
      // autoAlpha (opacity + visibility) so contrast checkers skip the
      // hidden element rather than flagging low-contrast text at opacity 0.
      autoAlpha: 0,
      duration: durMedium,
      ease: easeSnappy,
      scrollTrigger: { trigger: this.$el, start: 'top 85%', once: true },
    });
  },
});
